import { h } from 'preact';
import { useEffect } from 'preact/hooks';

import ReviewTwoLayout from '../../../components/layouts/ReviewTwoLayout';
import Visibility from '../../../components/visibility';
import ReviewTable from '../../../components/review';
import { batch, useSignal } from '@preact/signals';
import { createReviewTableData } from '../../../utils';
import { ReviewState } from '../../../states/kyc-review-state';
import { getRiskProfileQuestions } from '../../../controllers/OptionsController';

import RiskProfile from '../../../routes/riskprofile';

const RiskProfileReview = props => {
  const headers: any = useSignal([]);
  const body: any = useSignal([]);
  const isLoaded = useSignal(false);

  useEffect(() => {
    batch(() => {
      createReviewTableData(
        getRiskProfileQuestions,
        (res: { headers: []; body: [] }) => {
          setTimeout(() => {
            isLoaded.value = true;
          }, 1000);

          setTimeout(() => {
            body.value = res.body;
            headers.value = res.headers;
          }, 1100);
        },
        'getRiskProfileQuestions'
      );
    });
  }, []);

  return (
    <ReviewTwoLayout path={props.path} display="Risk Profile">
      <Visibility condition={ReviewState.isEditing.value}>
        <RiskProfile isReview={true} />
      </Visibility>

      <Visibility condition={!ReviewState.isEditing.value}>
        <ReviewTable
          headers={headers.value}
          body={body.value}
          isLoaded={isLoaded}
        />
      </Visibility>
    </ReviewTwoLayout>
  );
};

export default RiskProfileReview;
